import moment from 'moment';

export default class Offers {
  constructor({
    id,
    index,
    name,
    imageUrl,
    active,
    startDate,
    endDate,
    storeids,
    clusters,
    regions,
    roles,
    formats,
    submittedBy,
    submittedByName,
    createdAt
  }) {
    this.id = id || '';
    this.index = index + 1;
    this.name = name || '';
    this.imageUrl = imageUrl || '';
    this.active = active ? 'True' : 'False';
    this.storeids = storeids || '';
    this.startDate = startDate ? moment(startDate).format('LL') : null;
    this.endDate = endDate ? moment(endDate).format('LL') : null;
    this.clusters = clusters || '';
    this.regions = regions || '';
    this.roles = roles || '';
    this.formats = formats || '';
    this.submittedByName = submittedByName || '';
    this.createdAt = createdAt ? moment(createdAt).format('LL') : null;
    this.submittedBy = submittedBy || '';
  }
}
